export const getInviteCode = () => {
    const inviteCode = localStorage.getItem('giftly-invite-code');
    return inviteCode || '';
};
